import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-light text-center py-3 mt-4">
            <p>
                © 2025 JSON Tools Suite | Built with ❤️ by{' '}
                <a href="https://ca.linkedin.com/in/nitendra-s-58324453?trk=people-guest_people_search-card" target="_blank" rel="noopener noreferrer">
                    Nitendra Shukla
                </a>{' '}
                | <a href="https://sfdc247.com" target="_blank" rel="noopener noreferrer">SFDC247</a>
            </p>
        </footer>
    );
};

export default Footer;